import React, { useMemo } from "react";
import { Row, Col } from "reactstrap";

import BulkNotificationSignSignerList from "../../../../bulk/notification/sign/signer_list";

import { fetchCustomFieldValue, isAuthorizedCustomFieldToUser } from "../../../../helper/custom_field/helper";

const AbstractBulkNotificationSignForm = props => {
  const {
    currentUser,
    data: {
      customFields,
      currentEntityType,
      documentTypes,
    }
  } = props;

  const tableColumnsDefault = [
    {
      field: 'email',
      header: I18n.t('activerecord.attributes.signer.email'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el email del firmante',
        inputType: 'text',
        filterrific: {
          search: 'search_by_email'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'email_'
        }
      },
    },
    {
      field: 'role',
      header: I18n.t('activerecord.attributes.signer.role'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el rol del firmante',
        inputType: 'text',
        filterrific: {
          search: 'search_by_role'
        }
      },
    },
    {
      field: 'document.label',
      header: I18n.t("activerecord.attributes.document.label"),
      body: (row) => row?.document?.label || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre del documento',
        inputType: 'text',
        filterrific: {
          search: 'search_by_document_name'
        }
      },
    },
    {
      field: 'document_type.name',
      header: I18n.t("activerecord.attributes.document.document_type"),
      filter: {
        enabled: true,
        placeholder: 'Seleccione un tipo de documento',
        inputType: 'simple_select',
        options: _.map(documentTypes, type => ({
          value: type.id,
          label: type.name,
        })),
        filterrific: {
          search: 'by_document_type'
        }
      },
    },
    {
      field: 'created_at_to_s',
      header: `${I18n.t("activerecord.attributes.signer.created_at")}`,
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de solicitud',
        inputType: 'text',
        filterrific: {
          search: 'search_by_created_at'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'created_at_'
        }
      },
    },
  ]

  const tableColumnsCustomFields = useMemo(() => {
    return _.map(customFields, function (customField) {
      return {
        field: `document.entity.custom_fields.${ customField.code }`,
        header: _.capitalize(customField.label),
        body: (row) => {
          return fetchCustomFieldValue(customField, row.document.entity.custom_fields[customField.code], currentUser)
        },
        filter: {
          enabled: true,
          placeholder: `Ingrese ${ _.capitalize(customField.label) }`,
          filterrific: {
            search: 'search_by_key_custom_fields',
            searchKey: customField.code
          }
        },
        configuration: {
          isCustomField: true
        }
      }
    })
  }, [])

  const tableColumns = useMemo(() => {
    let columns = _.concat(
      tableColumnsDefault,
      tableColumnsCustomFields
    )

    return _.compact(columns)
  }, [])

  return (
    <Row>
      <Col md="12">
        <BulkNotificationSignSignerList
          dataTableConfiguration={{
            columns: tableColumns
          }}
          configuration={{
            showDistributionListFilter: false,
            context: 'abstract',
            defaultRequestParams: {"filterrific": { "by_aasm_state": "pending" }, "current_entity_type_id": currentEntityType.id},
            formName: 'abstract_bulk_notification_sign',
          }}
          routes={{
            indexSignersPath: Routes.abstract_signers_path,
          }}
        />
      </Col>
    </Row>
  );
};

export default AbstractBulkNotificationSignForm;
